<template>
  <custom-plane
    title="空气质量（室外）"
    :iconImg="require('@/assets/environment/env.png')"
  >
    <div class="air-content-top">
      <div class="air-item" v-for="item in airArray">
        <div class="name">{{ item.name }}</div>
        <div class="detail">
          <div class="detail-num">
            {{ item.num }}
          </div>
          <div class="detail-unit">
            {{ item.unit }}
          </div>
        </div>
      </div>
    </div>
    <div class="air-content-top air-content-tops">
      <div class="air-item" v-for="item in airArrayBot">
        <div class="name">{{ item.name }}</div>
        <div class="detail">
          <div
            class="detail-num"
            :class="{
              'feng-num': item.name == '风向',
              'error-color': item.alarm == '1',
            }"
          >
            {{ item.num }}
          </div>
          <div class="detail-unit">
            {{ item.unit }}
          </div>
        </div>
      </div>
    </div>
  </custom-plane>
</template>

<script>
export default {
  props: {
    airArray: Array,
    airArrayBot: Array,
  },
};
</script>

<style lang="scss" scoped>
.air-content-top {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .air-item {
    width: 98px;
    height: 57px;
    white-space: nowrap;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .name {
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      color: #e5e5e5;
    }
    .detail {
      color: #2d82ff;
      font-weight: 500;
      font-family: "dina";
      display: flex;
      align-items: baseline;
      .feng-num {
        font-family: "source" !important;
        font-size: 22px !important;
      }
      .detail-num {
        font-size: 28px;
        line-height: 32px;
        font-family: "dina";
      }
      .detail-unit {
        font-size: 14px;
        font-family: "dina";
      }
    }
  }
}
.air-content-tops {
  margin-top: -30px !important;
  .air-item {
    margin-bottom: 10px;
  }
}
</style>
